import Cookies from 'js-cookie';

export const recoverSessionId = () => {
  const url = new URL(window.location.href);
  const override = url.searchParams.get('sessionId');
  if (override) {
    Cookies.set('sessionId', override);
    return override;
  }
  const reset = '#new';
  if (window.location.hash === reset) {
    const { href } = window.location;
    window.location.replace(href.substring(0, href.length - reset.length));
    Cookies.remove('sessionId');
    return undefined;
  }
  return Cookies.get('sessionId');
};

export default recoverSessionId;
